import { Typography } from '@material-ui/core'
import React, { useState } from 'react'

import { CancelPolicy } from '../../types/cancelAndModifyPolicies'
import RatePlansPoliciesActionModal from '../RatePlansPolicies/RatePlansPoliciesActionModal'
import { PolicyRowMenu } from './PolicyRowMenu'
import useStyles from './styles/PoliciesTable.styles'

interface PolicyRowMobileProps {
  data: CancelPolicy
  providerCode: string
}

const PolicyRowMobile: React.FC<PolicyRowMobileProps> = ({
  data,
  providerCode
}) => {
  const classes = useStyles()
  const [modalIsOpen, setmodalIsOpen] = useState<boolean>(false)

  return (
    <>
      <div className={classes.tableRowMobile}>
        <div className={classes.nameCell}>
          <Typography variant="h4">{data.basicDetails.name}</Typography>
        </div>
        <div>
          <PolicyRowMenu
            id={data.basicDetails.id}
            openModal={() => setmodalIsOpen(true)}
            providerCode={providerCode}
          />
        </div>
      </div>
      <RatePlansPoliciesActionModal
        isOpen={modalIsOpen}
        onClose={() => setmodalIsOpen(false)}
        data={data.table}
      />
    </>
  )
}

export default PolicyRowMobile
